module.exports = __webpack_public_path__ + "img/no-data.bf3f2a4e.png";